var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvironmentEsg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7369_20358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 28C8 16.9543 16.9543 8 28 8C39.0457 8 48 16.9543 48 28C48 39.0457 39.0457 48 28 48C16.9543 48 8 39.0457 8 28Z",
    fill: "#DAF1E4"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7369_20358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2659 18.7265C37.0055 18.4666 36.6906 18.2678 36.344 18.1443C35.9975 18.0208 35.6278 17.9757 35.2618 18.0123C32.9343 18.2373 25.1067 19.2065 22.0834 22.2265C20.6382 23.6756 19.7812 25.6088 19.678 27.6528C19.5747 29.6968 20.2325 31.7066 21.5242 33.294L30.7409 24.0773C30.8981 23.9255 31.1086 23.8415 31.3271 23.8434C31.5456 23.8453 31.7546 23.933 31.9091 24.0875C32.0636 24.242 32.1512 24.451 32.1531 24.6695C32.155 24.888 32.071 25.0985 31.9192 25.2557L22.7059 34.4723C24.2928 35.7649 26.3024 36.4235 28.3465 36.3208C30.3905 36.2181 32.324 35.3615 33.7734 33.9165C36.8368 30.8523 37.7734 23.049 37.9893 20.7307C38.0245 20.3639 37.978 19.9939 37.8529 19.6473C37.7278 19.3007 37.5273 18.9862 37.2659 18.7265ZM22.0834 33.9165C22.2823 34.1148 22.4887 34.3012 22.7026 34.4757L19.4192 37.759C19.2617 37.9104 19.0509 37.9939 18.8324 37.9914C18.6139 37.9889 18.4051 37.9006 18.251 37.7457C18.0969 37.5907 18.0098 37.3814 18.0086 37.1629C18.0073 36.9443 18.0919 36.734 18.2442 36.5773L21.5276 33.294C21.702 33.5073 21.8873 33.7148 22.0834 33.9165Z",
    fill: "#374151"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7369_20358",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.278431 0 0 0 0 0.733333 0 0 0 0 0.462745 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7369_20358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7369_20358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7369_20358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(18 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironmentEsg);
export default __webpack_public_path__ + "static/media/EnvironmentEsg.c7cf03a20724efe2a02b25ae17f69041.svg";
export { ForwardRef as ReactComponent };